const modules = import.meta.glob('./*/index.md', { eager: true })

export const posts = Object.values(modules)
  .map((mod) => mod.default || mod)
  .sort((a, b) => new Date(b.frontmatter.date) - new Date(a.frontmatter.date))

export function getPostBySlug(slug) {
  return posts.find((post) => post.frontmatter.slug === slug)
}
